import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';

import { COLORS } from '../../../configs/colors';
import { Box } from '../../atoms/Box';
import { Typography } from '../../atoms/Typography';

export const RoleBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'flush',
})<{ flush?: boolean }>`
  width: 100%;
  box-sizing: border-box;
  ${({ flush }) =>
    flush
      ? ''
      : `
  border: 2px solid ${COLORS.CardBorder};
  border-radius: 5px;
  background-color: ${COLORS.CardBackground};
  margin-bottom: 10px;
  `}
`;

export const StructureTradingHourAddGrid = styled(Grid)`
  margin-top: 4px;
`;

export const TableGridContainer = styled(Grid)`
  margin-left: 5px;
  margin-right: 5px;
  border: 1px solid ${COLORS.CardBorder};
  border-radius: 5px;
`;

export const ColorPickerGrid = styled(Grid)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-bottom: 5px;
`;

export const SwitchGrid = styled(Grid)`
  margin-top: 10px;
  justify-content: center;
  align-items: center;
`;

export const StyledTypography = styled(Typography)`
  margin-bottom: 10px;
`;
